import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { PinLocation } from 'components/icons'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const Address: FC<CustomIconProps> = (props) => {
  return <PinLocation {...props} />
}

const AddressExports = {
  Address,
}

export default AddressExports
